/**
 * Handing a file the app already holds to the browser (task 828).
 *
 * The idiom is the one the API Docs panel established: an object URL and a
 * temporary anchor, clicked and removed. It lives here rather than in each
 * caller because artifacts introduce a second and third download site, and a
 * saved file that lands under the wrong name is not a small bug — the name is
 * how a User finds it again.
 *
 * **Why the bytes are in memory at all.** The obvious cheaper move — point an
 * anchor straight at the download URL — cannot work here: the API authenticates
 * with a bearer token that only the axios instance attaches (`services/api.ts`),
 * and a browser navigation carries no such header. So the response is read as a
 * blob through the same client as every other call. Safe by construction: the
 * engine caps artifact content at 10 MB (task 826).
 */

/** Save `blob` to the User's downloads as `filename`. */
export function saveBlobAsFile(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
